module.exports = __webpack_public_path__ + "img/recognition.1bebb345.svg";